import { apiRequest, ajaxWatched } from '../../shared/services';

export const META_UPDATED = 'META_UPDATED';

function metaUpdated(meta) {
    return {
        type: META_UPDATED,
        meta: meta
    }
};

export function ensureMeta(collectionId) {
    return (dispatch, getState) => {
        let state = getState();
        if ((!state.meta) || state.meta.id !== collectionId) {
            return updateMeta(collectionId)(dispatch, getState);
        }
    }
}

export function updateMeta(collectionId) {
    return (dispatch, getState) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState, '/api/collection/meta/' + collectionId)
                .then(json => dispatch(metaUpdated(json)))
        ));
    }
}